// Toggle between CloudImage and GCS serving URLs
const USE_CLOUDIMAGE = false; // Set to true to use CloudImage, false to use GCS

// CloudImage configuration (legacy)
// TODO: the avwxfsdnen.cloudimg.io host no longer resolves (NXDOMAIN), so the
// legacy path below is dead. It is unreachable while USE_CLOUDIMAGE is false —
// do NOT flip that flag back on. Remove getCloudImageURL_Legacy and this base
// URL once the CloudImage rewrite handling in getGCSImageURL is no longer
// needed for old URLs already stored in the database.
const cloudImageBaseUrl =
  'https://avwxfsdnen.cloudimg.io/v7/%originalImageUrl%?w=%width%%height%%filters%';

const defaultWidth = 150;

// CloudImage URL generator (legacy)
const getCloudImageURL_Legacy = options => {
  let imgUrl = cloudImageBaseUrl;
  let width = defaultWidth;
  let height = '';
  if (typeof options?.size === 'string') {
    const sizes = options?.size?.split('x');
    width = sizes[0];
    height = sizes[1] ? `&h=${sizes[1]}` : '';
  } else if (typeof options?.size === 'number') {
    width = options?.size;
  }
  imgUrl = imgUrl
    .replace('%width%', width || 150)
    .replace('%height%', height)
    .replace('%filters%', options.filter ? `&func=${options.filter}` : '')
    .replace('%originalImageUrl%', options.originalImageUrl);
  return imgUrl;
};

// GCS direct URLs (no resize - browsers handle this efficiently)
const getGCSImageURL = options => {
  const { originalImageUrl, filter } = options;

  // If the URL is a CloudImage URL, extract the original GCS URL
  // CloudImage URL format: https://avwxfsdnen.cloudimg.io/v7/%originalImageUrl%?w=%width%&h=%height%&func=%filter%
  // Or: https://avwxfsdnen.cloudimg.io/%operation%/%size%/%filter%/%originalImageUrl%
  if (originalImageUrl && originalImageUrl.includes('avwxfsdnen.cloudimg.io')) {
    // Handle v7 format: https://avwxfsdnen.cloudimg.io/v7/%originalImageUrl%?w=%width%...
    if (originalImageUrl.includes('/v7/')) {
      const v7Match = originalImageUrl.match(/\/v7\/([^?]+)/);
      if (v7Match && v7Match[1]) {
        try {
          return decodeURIComponent(v7Match[1]);
        } catch (e) {
          return v7Match[1];
        }
      }
    }
    // Handle standard format: https://avwxfsdnen.cloudimg.io/operation/size/filter/originalUrl
    const urlParts = originalImageUrl.split('/');
    // The original URL starts after the filter parameter (index 6)
    if (urlParts.length >= 7) {
      const originalUrl = urlParts.slice(6).join('/');
      try {
        return decodeURIComponent(originalUrl);
      } catch (e) {
        return originalUrl;
      }
    }
  }

  // Note: GCS doesn't support server-side filters like blur
  // Blur effects are handled client-side with CSS filter property
  if (filter && filter.includes('blur')) {
    // Filter is kept in the options for potential future use
    // Currently handled via CSS in styled components
  }

  // Return direct URL - modern browsers handle image rendering efficiently
  // Resizing parameters are ignored as GCS storage.googleapis.com URLs
  // don't support the =sXXX parameter (only works on *.appspot.com/_ah/img/ URLs)
  return originalImageUrl;
};

// Main URL generator - toggle between CloudImage and GCS
const getCloudImageURL = options => {
  return USE_CLOUDIMAGE ? getCloudImageURL_Legacy(options) : getGCSImageURL(options);
};

const getDimentions = (
  windowDimentions,
  originalWidth,
  originalHeight,
  newWidthPercent
) => {
  let newDimentions = {
    width: originalWidth,
    height: originalHeight
  };
  // scale down image to fit width of device screen
  if (newDimentions.width > windowDimentions.width && originalHeight) {
    const scaleFactor = windowDimentions.width / originalWidth;
    newDimentions = {
      width: Math.round(originalWidth * scaleFactor),
      height: Math.round(originalHeight * scaleFactor)
    };
  }
  // if the image is scaled in author app, scale down to that then
  if (newWidthPercent) {
    const scaleFactor = newWidthPercent / 100;
    newDimentions = {
      width: Math.round(newDimentions.width * scaleFactor),
      height: Math.round(newDimentions.height * scaleFactor)
    };
  }
  return newDimentions;
};

export default {
  getImageUrl: options => getCloudImageURL(options),
  getDimentions
};
